export interface ICardLoginResponse {
	applicationId: string;
	userProfile: ICardUserProfile;
}
export interface ICardUserProfile {
	customerCode: string;
	cardNumber: string;
}
export interface ITokenInfo {
	value: string;
	expires: Date;
}

export class CardLoginResponse implements ICardLoginResponse {
	applicationId: string;
	userProfile: ICardUserProfile;

	constructor(resp?: ICardLoginResponse) {
		let newResp: ICardLoginResponse = resp || {
			applicationId: undefined,
			userProfile: undefined,
		};

		this.read(newResp);
	}

	private read(resp: ICardLoginResponse): void {
		this.applicationId = resp.applicationId;
		this.userProfile = resp.userProfile;
	}
}

export class TokenInfo implements ITokenInfo {
	value: string;
	expires: Date;

	constructor(data?: ITokenInfo) {
		const newData: ITokenInfo = data || {
			expires: undefined,
			value: undefined,
		};
		this.read(newData);
	}

	private read(data: ITokenInfo): void {
		this.value = data.value;
		this.expires = new Date(data.expires);
	}
}
export interface ICreateApplicationResponse {
	appData: IAppData;
	appInfo: IAppInfo;
}
export class CreateApplicationResponse implements ICreateApplicationResponse {
	appData: IAppData;
	appInfo: IAppInfo;

	constructor(resp?: ICreateApplicationResponse) {
		let newResp: ICreateApplicationResponse = resp || {
			appData: undefined,
			appInfo: undefined,
		};

		this.read(newResp);
	}

	private read(newResp: ICreateApplicationResponse) {
		this.appData = newResp.appData;
		this.appInfo = newResp.appInfo;
	}
}
export interface IAppInfo {
	appId: string;
	status: string;
}
export interface IAppData {
	customerCode: number;
	debitCardNo: string;
	ibankUserId: string;
	accountNo: string;
	personalDetails: IPersonalDetails;
	contactMethods: IContantMethod[];
	// passport: IPassport;
	// idCard: IIdCard;
	idNo: string;
}
export interface IPersonalDetails {
	firstName: string;
	lastName: string;
	fathersName: string;
	mothersName: string;
	dateOfBirth: string;
	countryOfBirth: number;
	birthLocation: string;
	gender: number;
	occupation: number;
	taxId: string;
	username: string;
}
export class PersonalDetails implements IPersonalDetails {
	firstName: string;
	lastName: string;
	fathersName: string;
	mothersName: string;
	dateOfBirth: string;
	countryOfBirth: number;
	birthLocation: string;
	gender: number;
	occupation: number;
	taxId: string;
	username: string;

	constructor(resp?: IPersonalDetails) {
		let newResp: IPersonalDetails = resp || {
			firstName: undefined,
			lastName: undefined,
			fathersName: undefined,
			mothersName: undefined,
			dateOfBirth: undefined,
			countryOfBirth: undefined,
			birthLocation: undefined,
			gender: undefined,
			occupation: undefined,
			taxId: undefined,
			username: undefined,
		};

		this.read(newResp);
	}

	private read(newResp: IPersonalDetails) {
		this.firstName = newResp.firstName;
		this.lastName = newResp.lastName;
		this.fathersName = newResp.fathersName;
		this.mothersName = newResp.mothersName;
		this.dateOfBirth = newResp.dateOfBirth;
		this.countryOfBirth = newResp.countryOfBirth;
		this.birthLocation = newResp.birthLocation;
		this.gender = newResp.gender;
		this.occupation = newResp.occupation;
		this.taxId = newResp.taxId;
		this.username = newResp.username;
	}
}

export interface IContantMethod {
	type: number;
	value: string;
	verification: IVerification;
}
export class ContactMethod implements IContantMethod {
	type: number;
	value: string;
	verification: IVerification;

	constructor(item?: IContantMethod) {
		let newItem: IContantMethod = item || {
			type: undefined,
			value: undefined,
			verification: undefined,
		};

		this.read(newItem);
	}
	private read(newItem: IContantMethod) {
		this.type = newItem.type;
		this.value = newItem.value;
		this.verification = newItem.verification;
	}
}
export interface IVerification {
	isVerified: boolean;
	verificationWay: number;
}
export class AppData implements IAppData {
	customerCode: number;
	debitCardNo: string;
	ibankUserId: string;
	accountNo: string;
	personalDetails: IPersonalDetails;
	contactMethods: ContactMethod[];
	idNo: string;

	constructor(resp?: IAppData) {
		let newResp: IAppData = resp || {
			customerCode: undefined,
			debitCardNo: undefined,
			ibankUserId: undefined,
			accountNo: undefined,
			personalDetails: undefined,
			contactMethods: [],
			idNo: undefined,
		};

		this.read(newResp);
	}

	private read(newResp: IAppData) {
		this.customerCode = newResp.customerCode;
		this.debitCardNo = newResp.debitCardNo;
		this.ibankUserId = newResp.ibankUserId;
		this.accountNo = newResp.accountNo;
		this.personalDetails = newResp.personalDetails;
		this.idNo = newResp.idNo;
		this.contactMethods = [];
		if (newResp.contactMethods) {
			newResp.contactMethods.forEach((t) => this.contactMethods.push(new ContactMethod(t)));
		}
	}
}
export class AppInfo implements IAppInfo {
	appId: string;
	status: string;

	constructor(resp?: IAppInfo) {
		let newResp: IAppInfo = resp || {
			appId: undefined,
			status: undefined,
		};

		this.read(newResp);
	}

	private read(newResp: IAppInfo) {
		this.appId = newResp.appId;
		this.status = newResp.status;
	}
}
export interface IGetRegisteredMobileNumbersResponse {
	mobileNumber: string;
}
export interface ICheckUsernameAvailabilityResponse {
	usernameAvailability: boolean;
	ibUsername: string;
}
export class GetRegisteredMobileNumbersResponse implements IGetRegisteredMobileNumbersResponse {
	mobileNumber: string;

	constructor(resp?: IGetRegisteredMobileNumbersResponse) {
		let newResp: IGetRegisteredMobileNumbersResponse = resp || {
			mobileNumber: undefined,
		};

		this.read(newResp);
	}

	private read(newResp: IGetRegisteredMobileNumbersResponse) {
		this.mobileNumber = newResp.mobileNumber;
	}
}

export interface ISendCodeResponse {
	appId: string;
	verificationResult: IVerificationResult;
}
export class SendCodeResponse implements ISendCodeResponse {
	appId: string;
	verificationResult: IVerificationResult;

	constructor(resp?: ISendCodeResponse) {
		let newResp: ISendCodeResponse = resp || {
			verificationResult: undefined,
			appId: undefined,
		};

		this.read(newResp);
	}

	private read(newResp: ISendCodeResponse) {
		this.verificationResult = newResp.verificationResult;
		this.appId = newResp.appId;
	}
}

export interface IVerificationResult {
	verificationId: string;
	expiresOn: string;
}

export interface IVerifyCodeResponse {
	status: boolean;
}

/*Review after QA
export interface IGetApplicationResponse {
	appData: IAppData;
	appInfo: IAppInfo;
}
export interface IAddress {
	streetName: string;
	number: number;
	postalCode: string;
	region: string;
	city: string;
	apartment: string;
	addressType: number;
}
export interface IOnboarding {
	onboardingDocType: string;
	onboardingId: string;
	identityId: string;
	signedDocId: string;
}
export interface ISaveApplicationDataResponse {
	appData: IAppData;
	status: string;
}
*/
